import { FunctionComponent } from "react";
import { Marker } from "@vis.gl/react-google-maps";
import { routePinPath } from "./routePinPath";
import { useTranslation } from "react-i18next";
import { StartingPointMarker } from "./StartingPointMarker";

interface PlanMarkerProps {
  coordinates: {
    latitude: number;
    longitude: number;
  };
  ordinal: number;
  type?: "Tour" | "Goal" | "StartPoint";
  onPress?: () => void;
  zIndex?: number;
}

const MARKER_SIZE = 28;

const PlanMarker: FunctionComponent<PlanMarkerProps> = ({
  coordinates,
  ordinal,
  onPress,
  zIndex = 1000,
  type = "Tour",
}) => {
  const { t } = useTranslation();

  if (type === "StartPoint") {
    return (
      <StartingPointMarker
        position={{
          lat: coordinates.latitude,
          lng: coordinates.longitude,
        }}
        zIndex={zIndex}
        onPress={onPress}
      />
    );
  }

  return (
    <Marker
      position={{
        lat: coordinates.latitude,
        lng: coordinates.longitude,
      }}
      icon={{
        url: `data:image/svg+xml,${encodeURIComponent(routePinPath)}`,
        anchor: new google.maps.Point(MARKER_SIZE / 2, MARKER_SIZE / 2),
        scaledSize: new google.maps.Size(MARKER_SIZE, MARKER_SIZE),
      }}
      label={{
        text: `${ordinal}`,
        color: "#FFFFFF",
        className: "plan-marker-label",
        fontSize: "12px",
        fontWeight: "bold",
      }}
      title={t("screens.planNavigate.markerStop", {
        ordinal: ordinal.toString() as any,
      })}
      onClick={onPress}
      zIndex={zIndex}
    />
  );
};

export { PlanMarker };
